// DS: MO0.2.1
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Url } from '@wix/da-url';
import { BiData } from '@wix/da-bi/pkg/events';
import { ReferralType } from '@wix/da-bi/pkg/constants';
import TextButton from '@wix/da-ds/pkg/Buttons/TextButton';
import s from './CoreMonetizationAd.scss';
const CoreMonetizationAd = ({ boldText, text, withCTA })=>{
    const { t } = useTranslation();
    return /*#__PURE__*/ React.createElement("div", {
        className: s['root']
    }, boldText && /*#__PURE__*/ React.createElement("span", {
        className: s['ad-bold-text']
    }, boldText), /*#__PURE__*/ React.createElement("span", {
        className: s['ad-text']
    }, text), withCTA && /*#__PURE__*/ React.createElement(TextButton, {
        size: "small",
        variant: "core-orange",
        href: Url.coreMembershipLink(),
        target: "_blank",
        biData: BiData({
            evid: 375,
            referral_info: ReferralType.SUBSCRIPTIONS_CORE_EXPIRED
        })
    }, t('coreMonetizationAd.upgradeCTA')));
};
CoreMonetizationAd.displayName = 'CoreMonetizationAd';
export default CoreMonetizationAd;
